import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ConsumptionFilterStrategy } from 'src/app/api/api-campaigns.service.generated';
import { ButtonComponent } from "wecheer-common";

@Component({
  selector: 'app-filters-edit',
  templateUrl: './filters-edit.component.html',
  styleUrls: ['./filters-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    FormsModule,
    MatIconModule,
    ButtonComponent
  ]
})
export class FiltersEditComponent implements OnInit {

  @Input() filters: ConsumptionFilterStrategy[];
  @Output() filtersChange = new EventEmitter<ConsumptionFilterStrategy[]>();  // 2 way binding create Output of propName + Change

  constructor() { }

  ngOnInit() {
  }

  addConsumptionFilter() {
    if (!this.filters) this.filters = [];

    this.filters.push(new ConsumptionFilterStrategy({}));
  }

  onRemoveConsumptionFilter(index: number) {
    this.filters.splice(index, 1);
  }

  notifyChance() {
    this.filtersChange.emit(this.filters);
  }

}
